// removed by extract-text-webpack-plugin
module.exports = {"base":"Stub_base--1CXxl","isDemo":"Stub_isDemo--2DJg6","close":"Stub_close--3mVLQ","holder":"Stub_holder--3E_hT","title":"Stub_title--aKor6","message":"Stub_message--lpJ-P"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Stub/Stub.css
// module id = 1820
// module chunks = 16